import { useWorkbenchRunStatus } from '../workbench-run-status-context.js';
import { IndividualToolCall } from './individual-tool-call.js';

export interface AnnotatedToolCallProps {
	toolCallId: string;
	toolName: string;
	args: unknown;
	result: unknown;
	isError: boolean;
	status: 'running' | 'complete' | 'incomplete' | 'requires-action';
}

/**
 * Console row for a tool call, labelled with the annotations its tool
 * published into the pane's store. Subscribes to this call's two annotation
 * strings rather than the whole map, so an annotation landing on one call
 * re-renders only its own row.
 *
 * @param toolCallId - The call whose annotations to read.
 * @param toolName - Name of the tool.
 * @param args - Arguments passed to the tool.
 * @param result - Return value (undefined while running).
 * @param isError - Whether the call ended in an error.
 * @param status - Current execution status.
 */
export function AnnotatedToolCall({ toolCallId, ...toolCallProps }: AnnotatedToolCallProps) {
	const detail = useWorkbenchRunStatus((state) => state.toolCallAnnotations.get(toolCallId)?.detail);
	const displayName = useWorkbenchRunStatus((state) => state.toolCallAnnotations.get(toolCallId)?.displayName);

	return <IndividualToolCall {...toolCallProps} detail={detail} displayName={displayName} />;
}
